module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v(_vm._s(_vm.date))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ef839930"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/util/elapsed.vue
// module id = 1485
// module chunks = 0